import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import EmailIcon from "../../images/social-email.svg"
import FBIcon from "../../images/social-facebook.svg"
import InstaIcon from "../../images/social-instagram.svg"
import LinkIcon from "../../images/social-link.svg"
import LinkedinIcon from "../../images/social-linkedin.svg"
import YTIcon from "../../images/social-youtube.svg"
import Tick from "../../images/tick-white.svg"

const SocialButton = styled.a`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
  border-radius: 36px;
  text-indent: -999999em;
  background: #cacaca url(${LinkIcon}) 50% 50% no-repeat;
  background-size: 20px;
  cursor: pointer;

  :hover {
    background-color: ${props => props.theme.colors.coral};
  }

  ${props =>
    props.small &&
    css`
      width: 28px;
      height: 28px;
      background-size: 16px;
    `}

  ${props =>
    props.icon === "email" &&
    css`
      background-size: 18px;
      background-image: url(${EmailIcon});
      ${props.small && `background-size: 14px;`}
    `}

  ${props =>
    props.icon === "linkedIn" &&
    css`
      background-size: 15px;
      background-image: url(${LinkedinIcon});
      ${props.small && `background-size: 12px;`}
    `}
  
  ${props =>
    props.icon === "facebook" &&
    css`
      background-size: 9px;
      background-image: url(${FBIcon});
      ${props.small && `background-size: 8px;`}
    `}
  
    ${props =>
    props.icon === "youtube" &&
    css`
      background-image: url(${YTIcon});
      background-size: 19px;
      ${props.small && `background-size: 14px; `}
    `}
  ${props =>
    props.icon === "instagram" &&
    css`
      background-image: url(${InstaIcon});
      background-size: 20px;
      ${props.small && `background-size: 14px; `}
    `}
  ${props =>
    props.icon === "tick" &&
    css`
      background-size: 16px;
      background-image: url(${Tick});
      ${props.small && `background-size: 12px;`}
    `}
`

SocialButton.propTypes = {
  icon: PropTypes.oneOf([
    "tick",
    "facebook",
    "linkedIn",
    "email",
    "instagram",
    "youtube",
  ]),
  small: PropTypes.bool,
}

export default SocialButton
